/** @format */

import React, { useEffect } from "react";
import useSettings from "stores/settings";
import { observer } from "mobx-react-lite";
import { useRouter } from "next/router";
import { Tab, Tabs } from "react-bootstrap";
import Charge from "./Charge";
import UseCreditList from "./UseCreditList";
import ChargeList from "./ChargeList";
import PaymentCredit4 from "./PaymentCredit4";
import { PageTokenCheck } from "function/PageTokenCheck";
import SEO from "components/SEO";

//DatePicker
// import "date-fns";

/* 아임포트 테스트 */
// let IMP = window.IMP;
// var IMP = "";
// if (typeof window !== "undefined") {
//   IMP = window.IMP;
// }

const Payment = observer(({ headUrl, headTitle, headDesc }) => {
  const settings = useSettings();
  const router = useRouter();

  /* 로그인 체크 : url 이동 */
  useEffect(() => {
    PageTokenCheck(settings, router);
  }, []);

  return (
    <div className="w-full">
      <SEO url={headUrl} title={headTitle} desc={headDesc} />
      <div className="page-content w-full pt-12 pb-36">
        <h3 className="font-bold mb-2">크레딧 충전/현황</h3>
        <p className="text-gray mb-4">부족한 크레딧을 충전하고 사용내역,충전내역을 확인하세요</p>
        <TabList />
      </div>
    </div>
  );
});

const TabList = () => {
  return (
    <div className="aiso-tab tab-4">
      <Tabs defaultActiveKey="credit1" id="uncontrolled-tab-example">
        <Tab eventKey="credit1" title="크레딧 충전" className="test-tab bg-white">
          <Charge />
        </Tab>
        <Tab eventKey="credit2" title="사용 내역">
          <UseCreditList />
        </Tab>
        <Tab eventKey="credit3" title="충전 내역">
          <ChargeList />
        </Tab>
        <Tab eventKey="credit4" title="환불 내역">
          <PaymentCredit4 />
        </Tab>
      </Tabs>
    </div>
  );
};

Payment.getInitialProps = async () => {
  let headTitle = "AISO PAYMENT";
  let headDesc = "크레딧을 충전하여 앱을 사용하세요.";
  const headUrl = `https://aiso.ai/user/payment`;

  return { headUrl, headTitle, headDesc };
};
export default Payment;
